import CustomPhone from '@public/icons/phone_new.svg';
import React, { SVGProps } from 'react';

type CustomPhoneWrapperProps = SVGProps<SVGSVGElement>;
const CustomPhoneWrapper: React.FC<CustomPhoneWrapperProps> = (props) => {
  return <CustomPhone {...props} />;
};

export default CustomPhoneWrapper;
